import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';

const firebaseRef = firebase.database();

export default async function addInfoToAgreement(
	leadId,
	key,
	data,
	isEditClientForms
) {
	console.log('addInfoToAgreement ', leadId, key, data, isEditClientForms);
	if (key === 'purchaser' && !isEditClientForms) {
		let formRef = firebaseRef.ref(
			'/kavtek_agreements/' +
				PROJECT_CODE.projectCode +
				'/' +
				leadId +
				'/clientInfo/individual'
		);
		let newFormRef = await formRef.push();
		await newFormRef.set({
			firstName: data?.firstName,
			lastName: data?.lastName,
			email: data?.email,
			occupation: data?.occupation,
			phoneNumber: data?.phoneNumber,
			address1: data?.address1,
			address2: data?.address2 || '',
			city: data?.city,
			province: data?.province,
			postalCode: data?.postalCode,
			isPrimary: false,
		});
	} else if (key === 'purchaser' && isEditClientForms) {
		let clientInfoKey = data?.id;
		delete data['id'];
		let agreementRef =
			clientInfoKey &&
			firebaseRef.ref(
				'/kavtek_agreements/' +
					PROJECT_CODE.projectCode +
					'/' +
					leadId +
					'/clientInfo/individual/' +
					clientInfoKey
			);
		agreementRef && agreementRef.update(data);
	} else if (key === 'corporation') {
		let agreementRef = firebaseRef.ref(
			'/kavtek_agreements/' +
				PROJECT_CODE.projectCode +
				'/' +
				leadId +
				'/clientInfo'
		);
		agreementRef.update({
			[key]: data,
		});
	} else {
		let agreementRef = firebaseRef.ref(
			'/kavtek_agreements/' + PROJECT_CODE.projectCode + '/' + leadId
		);
		agreementRef.update({
			[key]: data,
		});
	}
}
